(() => {
  const configElement = document.getElementById('PopularProductsConfig');
  if (!configElement || customElements.get('popular-product-badge')) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch {
    return;
  }

  const cacheLifetime = 20 * 60 * 1000;
  const cacheKey = ['popular-products-v1', config.themeId, config.url, config.country, config.language].join(':');
  let rankingPromise;

  function validIds(ids) {
    return Array.isArray(ids) && ids.length <= 50 &&
      ids.every(id => typeof id === 'string' && /^\d+$/.test(id)) &&
      new Set(ids).size === ids.length;
  }

  function cachedRanking() {
    if (config.designMode) return null;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey));
      if (cached && Number.isFinite(cached.savedAt) && cached.savedAt <= Date.now() &&
          Date.now() - cached.savedAt < cacheLifetime && validIds(cached.ids)) return cached.ids;
    } catch {}
    return null;
  }

  async function fetchRanking() {
    const cached = cachedRanking();
    if (cached) return cached;

    const url = new URL(config.url, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid popular products URL');
    url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('page', '1');
    url.searchParams.set('section_id', 'popular-products-data');

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Popular products unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(html.querySelector('[data-popular-products]')?.textContent || 'null');
      if (!data || data.collection !== 'all' || data.sortBy !== 'best-selling' || !validIds(data.productIds)) {
        throw new Error('Invalid popular products response');
      }
      if (!config.designMode) {
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), ids: data.productIds }));
        } catch {}
      }
      return data.productIds;
    } finally {
      clearTimeout(timeout);
    }
  }

  function loadRanking() {
    if (!rankingPromise) rankingPromise = fetchRanking().catch(() => null);
    return rankingPromise;
  }

  customElements.define('popular-product-badge', class extends HTMLElement {
    static get observedAttributes() {
      return ['data-product-id', 'data-count'];
    }

    connectedCallback() {
      this.update();
    }

    attributeChangedCallback() {
      if (this.isConnected) this.update();
    }

    async update() {
      const generation = this.generation = (this.generation || 0) + 1;
      this.hidden = true;
      const productId = this.dataset.productId;
      if (!/^\d+$/.test(productId || '')) return;
      const requestedCount = Number.parseInt(this.dataset.count, 10);
      const count = Number.isFinite(requestedCount) ? Math.min(50, Math.max(1, requestedCount)) : 5;
      const ids = await loadRanking();
      if (!this.isConnected || generation !== this.generation || !ids) return;
      this.hidden = !ids.slice(0, count).includes(productId);
    }
  });
})();
